import { useWindowWidth } from "@react-hook/window-size";
import { MOBILE_BREAKPOINT } from "@olivahealth/oli-ui/utils/breakpoints";

export default function useSmallScreenDetection() {
  const width = useWindowWidth();

  return width < MOBILE_BREAKPOINT;
}
